// @flow
import { defineMessages } from 'react-intl';

export default defineMessages({
    cookiePolicyMessage: {
        id: 'cookie-policy.message',
        defaultMessage: 'By continuing to use this site you agree to our cookie policy'
    },
    cookiePolicyLink: {
        id: 'cookie-policy.link',
        defaultMessage: '(see the cookie policy here).'
    },
    cookiePolicyURL: {
        id: 'cookie-policy.url',
        defaultMessage: 'https://www.hivehome.com/cookies'
    },
    cookiePolicyConfirm: {
        id: 'cookie-policy.confirm',
        defaultMessage: "Don't show this message again"
    }
});



// WEBPACK FOOTER //
// ./src/components/widgets/cookie-policy/intl.js